/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getPagesInDOM, getTotalPages, getPagesInView } from "selectors/documentSelectors";
import { TabbingSupport } from "components/accessibility/TabbingSupport";
import { shouldRenderTabbingSupport } from "selectors/accessibilitySelectors";
import { findAndFocusTabbableItemInsideDOM, findAndFocusTabbableItemOutsideDOM } from "utils/AccessibilityUtils";

const mapStoresToProps = stores => ({
  shouldRender: shouldRenderTabbingSupport(stores),
  onFocus: () => {
    const { start: firstPageInDOM, end: lastPageInDOM } = getPagesInDOM(stores);
    const { end: lastPageInView } = getPagesInView(stores);

    for (let pageIndex = lastPageInView; pageIndex >= firstPageInDOM; pageIndex--)
      if (findAndFocusTabbableItemInsideDOM(stores, pageIndex, false)) return;
    for (let pageIndex = firstPageInDOM - 1; pageIndex >= 0; pageIndex--)
      if (findAndFocusTabbableItemOutsideDOM(stores, pageIndex, false)) return;
    for (let pageIndex = getTotalPages(stores) - 1; pageIndex > lastPageInDOM; pageIndex--)
      if (findAndFocusTabbableItemOutsideDOM(stores, pageIndex, false)) return;
    for (let pageIndex = lastPageInDOM; pageIndex > lastPageInView; pageIndex--)
      if (findAndFocusTabbableItemInsideDOM(stores, pageIndex, false)) return;
  },
  testId: "backward-tabbing"
});

const BackwardTabbingContainer = inject(mapStoresToProps)(TabbingSupport);

export { BackwardTabbingContainer };
